
import { computed, defineComponent, ref } from 'vue'
import { provideRouter } from '@invivodf/common/src/application/composables/useRouter'
import { provideSeller, Seller } from '@invivodf/common/src/application/composables/useSeller'
import {
  getCurrentContext,
  isRetailContext,
  provideContext,
} from '@invivodf/common/src/application/composables/useContext'
import {
  provideLogisticOfferFormSteps,
  useAladinFormSteps,
  useRetailFormSteps,
} from '@invivodf/common/src/contexts/logistic-offer/application/composables'
import { checkFeature, FeatureType } from '@invivodf/front-seller-feature-flipping'
import { usePartner } from '@/composables/usePartner'
import { provideStore } from '@/composables/useStore'
import { useSeller as useRetailSeller } from '@/retail/application/composables/useSeller'
import { microFrontListenerCore } from '@b2ag/micro-front-tools'
import { getRouter } from './router/index'
import { getStore } from './store'

export default defineComponent({
  name: 'App',
  setup() {
    const isRetail = isRetailContext()

    const router = getRouter()
    provideRouter(router)
    provideContext(getCurrentContext())
    provideLogisticOfferFormSteps(isRetail ? useRetailFormSteps() : useAladinFormSteps())

    microFrontListenerCore({
      // @ts-ignore will be removed when front-b2ag migrates to vue 3
      router,
      callbackForMessages: () => {},
      uniqObject: 'default',
    })

    const isFTTestEnabled = ref(false)

    // Retail world: no Vuex store, seller comes from the retail composable.
    if (isRetail) {
      provideSeller(useRetailSeller())
      return { isFTTestEnabled }
    }

    // B2ag world: Vuex store, partner-derived seller and feature flipping.
    provideStore(getStore())
    const { distributorId, partnerName } = usePartner()

    checkFeature
      .execute({
        id: `offers:test`,
        type: FeatureType.Dynamic,
      })
      .then((active) => {
        isFTTestEnabled.value = active
      })

    provideSeller(
      computed(
        () =>
          ({
            id: distributorId.value,
            name: partnerName.value,
          }) as Seller,
      ),
    )

    return {
      isFTTestEnabled,
    }
  },
  beforeMount() {
    const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
    link.href = `/icons/${window.env.VUE_APP_CONTEXT}/favicon.ico`
    document.getElementsByTagName('head')[0].appendChild(link)
  },
})
